module.exports = __webpack_public_path__ + "static/img/mobile_home_cpjfw_hwaqapp.d7c8eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_cpjfw_hwaqapp.png
// module id = tbNw
// module chunks = 21